// extracted by mini-css-extract-plugin
export default {"header":"modal-header_header__hp4FC","title":"modal-header_title__Ewnh+","button":"modal-header_button__o0UNJ"};